var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockClosed = function SvgLockClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M40.5 18h-32v25h32zM32.5 12a8 8 0 1 0-16 0v6h16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M26.5 31.465a4 4 0 1 0-4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M26.5 31v6h-4v-6"
  })));
};
export default SvgLockClosed;